export type SidebarWidth = "narrow" | "medium" | "wide";
export type SidebarMode = "full" | "drawer";
export type SidebarPreferences = { collapsed?: boolean };

export function sidebarWidth(width: number): SidebarWidth {
  return width <= 900 ? "narrow" : width < 1200 ? "medium" : "wide";
}

export function sidebarMode(width: SidebarWidth, preferences: SidebarPreferences): SidebarMode {
  return width === "narrow" || preferences.collapsed ? "drawer" : "full";
}

const preferenceKey = (scope: string) => `classroom-sidebar-v2:${scope}`;

export function readSidebarPreferences(scope: string): SidebarPreferences {
  try {
    const stored = JSON.parse(window.localStorage.getItem(preferenceKey(scope)) || "null");
    if (stored?.version !== 2 || typeof stored.collapsed !== "boolean") return {};
    return { collapsed: stored.collapsed };
  } catch {
    return {};
  }
}

export function saveSidebarPreferences(scope: string, preferences: SidebarPreferences) {
  try {
    window.localStorage.setItem(preferenceKey(scope), JSON.stringify({ version: 2, ...preferences }));
  } catch {
    // A blocked browser preference store must not prevent navigation.
  }
}
